import React from 'react';
import classNames from 'classnames';
import ClickableHelpIcon from 'components/pure/utils/ClickableHelpIcon';
import './HelpHover.styl';

export default class HelpHover extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.state = {};
  }
  onMouseEnter() {
    this.setState({hovered: true});
  }
  onMouseLeave() {
    this.setState({hovered: false});
  }
  render() {
    const {text, className, children, elType} = this.props;
    const ElType = elType ? elType : 'div';
    return (
      <ElType
        className={classNames('help-hover', className)}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}>
        {children}
        {this.state.hovered && <ClickableHelpIcon text={text} className={className} />}
      </ElType>
    );
  }
}
